import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginBottom: '12px'
  },
  heading: {
    fontSize: theme.typography.pxToRem(18),
    //fontWeight: theme.typography.fontWeightRegular,
    color: 'black'
  },
  labels: {
    color: 'rgb(118, 118, 118)'
  },
  button: {},
  flexContainer: {
    display: 'flex',
    flexFlow: 'row nowrap',
    width: '100%'
  },
  aplicar: {
    // marginLeft: '-5px',
    marginTop: '10px'
  },
  dtBox: {
    width: '120px',
    overflow: 'hidden'
  }
}));
